import { ArticleNavigationContext } from '@bridge/navigationStore';

export interface NavigationRouteItem {
  icon?: 'manage' | 'files' | 'tasks' | 'productApproval';
  label: string;
  route: string;
}

export const customerItems: NavigationRouteItem[] = [
  { label: 'navigation.articles', route: 'customer.articles' },
  { label: 'navigation.concepts', route: 'customer.concepts' },
  { label: 'navigation.team', route: 'customer.users' },
  { label: 'navigation.contacts', route: 'customer.contacts' },
  {
    label: 'customerComplianceDocuments.title',
    route: 'customer.complianceDocuments',
  },
];

export const customerUtilityItems: NavigationRouteItem[] = [
  {
    icon: 'manage',
    label: 'navigation.manage',
    route: 'customer.management',
  },
  { icon: 'files', label: 'navigation.files', route: 'customer.files.id' },
  { icon: 'tasks', label: 'navigation.tasks', route: 'customer.tasks' },
];

export const conceptItems: NavigationRouteItem[] = [
  { label: 'navigation.articles', route: 'concept.articles' },
];

export const conceptUtilityItems: NavigationRouteItem[] = [
  {
    icon: 'manage',
    label: 'navigation.manage',
    route: 'concept.management',
  },
  { icon: 'files', label: 'navigation.files', route: 'concept.files.id' },
  { icon: 'tasks', label: 'navigation.tasks', route: 'concept.tasks' },
];

export const articleUtilityItems: NavigationRouteItem[] = [
  {
    icon: 'manage',
    label: 'navigation.manage',
    route: 'article.management',
  },
  { icon: 'files', label: 'navigation.files', route: 'article.files.id' },
  { icon: 'tasks', label: 'navigation.tasks', route: 'article.tasks' },
  {
    icon: 'productApproval',
    label: 'navigation.productApproval',
    route: 'article.productApproval',
  },
];

export function isStateActive(activeState: string, route: string) {
  return activeState === route || activeState.startsWith(`${route}.`);
}

export function getArticleItems(
  context: ArticleNavigationContext,
  variantId: number | null = context.currentVariantId,
  isProduction = false,
): NavigationRouteItem[] {
  const variant = context.variants.find((item) => item.id === variantId);
  if (!variant) {
    return [];
  }

  return [
    { label: 'navigation.overview', route: 'variant.overview' },
    ...(variant.isProductDevelopment
      ? [{ label: 'navigation.options', route: 'variant.options' }]
      : []),
    { label: 'navigation.suppliers', route: 'variant.suppliers' },
    ...(variant.isProductDevelopment
      ? [{ label: 'navigation.versions', route: 'variant.versions' }]
      : []),
    ...(variant.isProductDevelopment && context.betaFeatures && !isProduction
      ? [
          { label: 'navigation.inquiry', route: 'variant.inquiry' },
          { label: 'navigation.offers', route: 'variant.offers' },
        ]
      : []),
    ...(!variant.isProductDevelopment
      ? [
          { label: 'navigation.purchase', route: 'variant.purchase' },
          { label: 'navigation.sales', route: 'variant.sales' },
        ]
      : []),
    ...(!variant.isProductDevelopment && context.article.hasMatrix
      ? [{ label: 'navigation.matrix', route: 'variant.matrix' }]
      : []),
    ...(!variant.isProductDevelopment
      ? [{ label: 'navigation.garp', route: 'variant.general.garp' }]
      : []),
  ];
}
